import React from 'react';
import { Box, Grid } from '@mui/material';
import MyDayShoppingListCard from './my_day_shopping_list_card';
import {
  useGetShoppingListsByProductsBoardQuery,
  useListProductsBoardQuery,
} from '../../app/smorgAppSyncGraphQLApi';
import MyDayPlaceholderSection from './my_day_placeholder_section';

const MyDayShoppingListsSection = () => {
  const { data: productsBoard, isSuccess: isProductsBoardSuccess } =
    useListProductsBoardQuery();

  const { data: shoppingListsDict, isSuccess: isShoppingListsSuccess } =
    useGetShoppingListsByProductsBoardQuery(productsBoard?.id, {
      skip: !productsBoard?.id,
    });

  const shoppingLists = Object.values(shoppingListsDict || {});

  const hasLoadedSuccessfully =
    isProductsBoardSuccess && isShoppingListsSuccess;

  if (!isProductsBoardSuccess) {
    return <MyDayPlaceholderSection title="Loading lists..." />;
  }

  if (isProductsBoardSuccess && !productsBoard) {
    return null;
  }

  if (!isShoppingListsSuccess) {
    return <MyDayPlaceholderSection title="Loading lists..." />;
  }

  if (hasLoadedSuccessfully && shoppingLists.length === 0) {
    return null;
  }

  return (
    <>
      <Grid container>
        <Grid item xs={8}>
          <h2
            style={{
              margin: '23px 23px 5px',
              color: 'var(--app-primary-font-color)',
            }}>
            Shopping lists
          </h2>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}>
          <Box sx={{ margin: 'auto 10px' }}>&nbsp;</Box>
        </Grid>
      </Grid>

      <div style={{ overflowX: 'auto', display: 'flex' }}>
        {shoppingLists.map((shoppingList) => (
          <div key={shoppingList.id} style={{ flexShrink: 0 }}>
            <MyDayShoppingListCard shoppingListID={shoppingList.id} />
          </div>
        ))}
      </div>
    </>
  );
};

export default MyDayShoppingListsSection;
